import { Arrow, Container, Line } from "../../Styles/Global.Styled";
import { css } from "styled-components";

const centerAlign = css`
  align-items: center;
`;
const lineStyle = css`
  width: 98%;
  position: absolute;
  border-width: 0 0.5vh 0.5vh 0;
`;
const arrowStyle = css`
  position: absolute;
  right: 0;
`;

const LineArrow = ({ direction, style }) => {
  return (
    <Container $baseStyle={centerAlign} style={style}>
      <Line $baseStyle={lineStyle} />
      <Arrow $baseStyle={arrowStyle} $direction={direction} />
    </Container>
  );
};

export default LineArrow;
